<script>
import { browser } from '@/mixins/main'
import buttonPosition from '@/mixins/lib/buttonPosition'

export default {
    name: 'StorySocials',
    props: ['type', 'staticPosition'],
    mixins: [browser],
    data() {
        return {
            size: 200,
            urls: {
                instagram: 'https://www.instagram.com/doanegrantthorntoncareers',
                facebook: 'https://www.facebook.com/DoaneGrantThorntonCareers/',
                linkedin: 'https://linkedin.com/company/doane-grant-thornton-llp/',
                tiktok: 'https://www.tiktok.com/@doanegrantthornton',
            },
            svgs: {
                instagram: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>`,
                facebook: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg></a>`,
                linkedin: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/></svg>`,
                tiktok: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 406.89 462.09"><path d="M405.78 125.7c-56.82 0-102.88-46.06-102.88-102.88h-77.16v298.65c0 34.72-28.15 62.87-62.87 62.87S100 356.19 100 321.47s28.15-62.87 62.87-62.87c6.51 0 13.89.99 19.79 2.83v-78.6a142.06 142.06 0 0 0-19.79-1.39c-77.34 0-140.04 62.7-140.04 140.04s62.7 140.04 140.04 140.04 140.04-62.7 140.04-140.04V163.4c28.05 22.88 63.86 36.61 102.88 36.61V125.7Z" style="fill:#ff0b53"/><path d="M383.92 103.84c-56.82 0-102.88-46.06-102.88-102.88h-77.16v298.65c0 34.72-28.15 62.87-62.87 62.87s-62.87-28.15-62.87-62.87 28.15-62.87 62.87-62.87c6.51 0 13.89.99 19.79 2.83v-78.6c-6.47-.92-13.07-1.39-19.79-1.39C63.66 159.57.96 222.27.96 299.61S63.66 439.65 141 439.65s140.04-62.7 140.04-140.04V141.54c28.05 22.88 63.86 36.61 102.88 36.61v-74.31Z" style="fill:#00f0e9"/><path d="M383.92 123.35c-24.87-5.38-46.39-19.75-60.99-39.54-19.8-14.6-34.16-36.12-39.54-60.99h-57.65v298.65c0 34.72-28.15 62.87-62.87 62.87-22.97 0-43.05-12.32-54.02-30.71-18.39-10.97-30.71-31.05-30.71-54.02 0-34.72 28.15-62.87 62.87-62.87 6.51 0 13.89.99 19.79 2.83v-58.11c-76.39 1.11-137.97 63.36-137.97 140.01 0 33.1 11.49 63.51 30.69 87.48 23.97 19.2 54.38 30.7 87.48 30.7 77.34 0 140.04-62.7 140.04-140.04V141.54c28.05 22.88 63.86 36.61 102.88 36.61v-54.8Z" style="fill:#fff"/></svg>`,
            }
        }
    },
    mounted() {
        this.handleButtons()
    },
    watch: {
        browserSize() {
            this.handleButtons()
        },
    },
    methods: {
        degreeFromValue: (val, d = 80) => {
            return parseInt(d - val)
        },
        handleButtons() {
            if ( this.staticPosition ) {
                return;
            }
            this.size = this.$el.clientWidth
            const S = (60 / this.size * 100)

            Object.keys(this.svgs).map( (name, i) => {
                let degree = this.isMobile() 
                    ? this.degreeFromValue( i * 24, 120 )
                    : this.degreeFromValue( i * S * 1.3 )

                this.position( this.$refs[name], degree )
            })

        },
        position( el, degrees ) {
            const [ elem ] = el
            if ( elem ) setTimeout( () => {

                const space = 40
                this.size = this.$el.clientWidth
                elem.style.height = space + 'px'

                if ( this.staticPosition ) return;

                const point = buttonPosition(this.size, space, degrees)
                elem.style.left = 'calc('+ (parseInt( point[0] ) ) +'px)'
                elem.style.top = 'calc('+ (parseInt( point[1] ) ) +'px)'

            }, 500)

        }
    },
    template: `
    <ul :class="[type==='story' ? 'story__socials' : 'slide__socials']">
        <li v-for="(icon, name) in svgs" :ref="name" :key="name">
            <a :aria-label="'See our '+name" :href="urls[name]" target="_blank" rel=noopener :class="'social social--' + name" v-html="icon"></a>
        </li>
    </ul>
    `
}
</script>
